import React from "react";
import { TranslatableString, } from "@rjsf/utils";
export default function ErrorList({ errors, registry }) {
    const { translateString } = registry;
    return (React.createElement("div", { className: "mb-4 rounded border border-red-700" },
        React.createElement("div", { className: "rounded-t bg-red-100 p-3 text-red-950" }, translateString(TranslatableString.ErrorsLabel)),
        React.createElement("div", { className: "p-3" },
            React.createElement("ul", { className: "list-disc pl-5" }, errors.map((error, i) => (React.createElement("li", { key: i, className: "mb-1 text-red-600" }, error.stack)))))));
}
//# sourceMappingURL=ErrorList.js.map